import { InfiniteScroll, DotLoading } from "antd-mobile";
import { FormattedMessage } from "react-intl";

type IProps = {
  loadMore: () => Promise<void>;
  hasMore: boolean;
};

export const LoadMore: React.FC<IProps> = ({ loadMore, hasMore }) => {
  return (
    <InfiniteScroll loadMore={loadMore} hasMore={hasMore} threshold={10}>
      <div className="w-full flex items-center justify-center gap-1">
        {hasMore ? (
          <>
            <span>
              <FormattedMessage id="meter.load.more" />
            </span>
            <DotLoading />
          </>
        ) : (
          <span>
            <FormattedMessage id="meter.load.noMore" />
          </span>
        )}
      </div>
    </InfiniteScroll>
  );
};
